__turbopack_context__.v({
  "chip": "CategoryFilterChips-module__hvPq2G__chip",
  "group": "CategoryFilterChips-module__hvPq2G__group",
});
